var l = Object.defineProperty;
var a = (e, s, i) => s in e ? l(e, s, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[s] = i;
var o = (e, s, i) => (a(e, typeof s != "symbol" ? s + "" : s, i), i);
import { hexToRGB as p } from "@placer-ui/components";
import { GeoJsonLayer as h, SolidPolygonLayer as d, PathLayer as r } from "@deck.gl/layers/typed";
import { opacityToAlpha as t } from "./index.es60.js";
class n extends h {
  renderLayers() {
    const { layerProps: s } = this.state, i = this.getSubLayerProps();
    return [
      new d({
        ...i,
        ...s.polygons,
        id: `${this.props.id}-fill`,
        visible: this.props.visible,
        getFillColor: [
          ...p(this.props.fillColor),
          this.props.fillVisible ? t(this.props.fillOpacity / 100) : 0
        ],
        pickable: !1,
        stroked: !1,
        wireframe: !1,
        filled: !0,
        updateTriggers: {
          getFillColor: [
            this.props.basemapType,
            this.props.fillColor,
            this.props.fillOpacity,
            this.props.fillVisible
          ]
        }
      }),
      new r({
        ...i,
        ...s.polygonsOutline,
        id: `${this.props.id}-outer-line`,
        visible: this.props.visible,
        getColor: () => [
          255,
          255,
          255,
          this.props.strokeVisible ? t(this.props.strokeOpacity / 100) : 0
        ],
        widthUnits: "pixels",
        getWidth: this.props.strokeWidth,
        widthScale: 0.95,
        capRounded: !0,
        jointRounded: !0,
        pickable: !1,
        updateTriggers: {
          getWidth: [this.props.strokeWidth, this.props.basemapType],
          getColor: [
            this.props.strokeColor,
            this.props.strokeVisible,
            this.props.strokeOpacity,
            this.props.basemapType
          ]
        }
      }),
      new r({
        ...i,
        ...s.polygonsOutline,
        id: `${this.props.id}-inner-line`,
        visible: this.props.visible,
        getColor: () => [
          ...p(this.props.strokeColor),
          this.props.strokeVisible ? t(this.props.strokeOpacity / 100) : 0
        ],
        widthUnits: "pixels",
        getWidth: this.props.strokeWidth / 1.5,
        widthScale: 0.95,
        capRounded: !0,
        jointRounded: !0,
        pickable: !1,
        updateTriggers: {
          getWidth: [this.props.strokeWidth, this.props.basemapType],
          getColor: [
            this.props.strokeColor,
            this.props.strokeVisible,
            this.props.strokeOpacity,
            this.props.basemapType
          ]
        }
      })
    ];
  }
}
o(n, "layerName", "PLBoundaryPolygonGeoJsonLayer");
export {
  n as PLBoundaryPolygonGeoJsonLayer
};
//# sourceMappingURL=index.es300.js.map
